import createGlobalState from "@ui/lib/createGlobalState";
import * as io from "io-ts";

export const useDisplayAllQuantities = createGlobalState({
  storage: "session",
  key: "useDisplayAllQuantities",
  type: io.boolean,
  defaultValue: false,
  scoped: true,
});
